import { render, staticRenderFns } from "./FeedBackTable.vue?vue&type=template&id=74283cf1&"
import script from "./FeedBackTable.vue?vue&type=script&lang=js&"
export * from "./FeedBackTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports